/**
 * defa.models.Invoice
 * The DEFA invoice model.
 * @version 1.2.1
 */
import { defa, T } from 'defa-object';
import Usages      from 'scripts/defa/invoices/collection-usages';
import Model       from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );

const api = {
	invoices: defa.vars.apiHost + '/invoices',
};

const Invoice = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.invoices,
	
	defaults: {
		invoiceNumber           : '',
		counterInvoice          : null,
		created                 : '',
		issued                  : '',
		due                     : '',
		status                  : '',
		customer                : null,
		
		transientCounterInvoice : '',
		transientSumAmount      : '',   // sum all prices without vat.
		transientSumTotal       : '',   // sum all prices with vat.
		transientSumVat         : '',   // sum all vat.
	},
	
	completeList: [ 'xxx' ],
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the invoice's customer as long as he is in the channel.
	 * @void
	 */
	getCustomer: function () {
		
		return channel.request( 'customers' ).get( this.get( 'customer' ) );
	},
	
	/**
	 * Gets the usages linked to this invoice.
	 * @void
	 */
	getUsages: function () {
		// usages have no ID, so we can't place them in a channel.
		//var arr = channel.request( 'usages' ).where({ invoice: this.get( 'id' ) });
		
		return new Usages( this.get( 'usages' ) );
	},
	
	/**
	 * An invoice's title consists of it's date, and the invoiceNumber.
	 * @return {string}  The combined string of date and invoice number.
	 */
	getDate: function () {
		let date = new Date( this.get( 'issued' ) || this.get( 'created' ) );
		return date.format( T.dateFormatShort );
	},
	
	/**
	 * Parses incoming server data before using them as attributes.
	 * @param  {object} response  The server response data.
	 * @return {object}           The parsed server response data.
	 * @overwrite
	 * @void
	 */
	parse: function ( response ) {
		
		if ( response.customer.id ) {
			channel.request( 'customers' ).add( response.customer, { merge: true } );
		}
		let usages;
		if ( response.usages ) {
			// save the usages, so we can return them to the response later
			usages = response.usages;
			
			// usages comes without an ID, so we can't place them in a channel.
			// channel.request( 'usages' ).add( response.usages, { merge: true });
		}
		
		if ( response.invoice ) {
			response = response.invoice;
			// return the usages
			if ( usages ) {
				response.usages = usages;
			}
		}
		
		channel.request( 'invoices' ).add( response, { merge: true } );
		
		return response;
	},
	
} );


export default Invoice;
